import { lazy as d } from "react";
const y = "forceReloadedImportFunctions";
class f {
  constructor(e = y) {
    this.storageKey = e;
  }
  /**
   * Returns a map of function names and the number of times they have been force-reloaded. The map
   * is retrieved and parsed from the session storage.
   *
   * @example
   * Given that the session storage contains the following:
   *
   * ```json
   * { "forceReloadedFunctionNames": "[[\"functionName\", 1]]" }
   * ```
   *
   * The following code will return a map as the comment indicates:
   *
   * ```ts
   * const storage = new ForceReloadStorage();
   * const stored = storage.getMap(); // Map { 'functionName' => 1 }
   * ```
   */
  getMap() {
    const e = sessionStorage.getItem(this.storageKey);
    try {
      const t = e ? JSON.parse(e) : {};
      return new Map(
        Array.isArray(t) ? t.filter(
          (o) => Array.isArray(o) && typeof o[0] == "string" && typeof o[1] == "number"
        ) : void 0
      );
    } catch (t) {
      return console.error(t), /* @__PURE__ */ new Map();
    }
  }
  /**
   * Adds a function name to the storage. If the function name already exists, the number of times it
   * has been force-reloaded is incremented.
   *
   * @param functionName - The name of the function to add.
   */
  addFunction(e) {
    const t = this.getMap();
    t.set(e, (t.get(e) ?? 0) + 1), this.save(t);
  }
  /**
   * Removes a function name from the storage. Note that this will clear the force-reload count for
   * the function.
   *
   * If the function name does not exist, nothing happens.
   *
   * @param functionName - The name of the function to remove.
   */
  removeFunction(e) {
    const t = this.getMap();
    t.delete(e), this.save(t);
  }
  save(e) {
    sessionStorage.setItem(this.storageKey, JSON.stringify([...e.entries()]));
  }
}
const g = (r = {}) => ({
  forceReload: {
    maxRetries: 1,
    ...typeof r.forceReload == "object" ? r.forceReload : r.forceReload === !1 ? { maxRetries: 0 } : void 0
  },
  importRetries: typeof r.importRetries == "number" ? r.importRetries : 0
}), l = (r = {}) => {
  const { forceReload: e, importRetries: t } = g(r), o = new f(e.storageKey);
  return (n) => {
    let c = 0;
    const i = async () => {
      try {
        return await n();
      } catch (s) {
        if (console.error(s), c < t)
          return c++, i();
        throw s;
      }
    }, a = n.toString();
    return d(async () => {
      try {
        const s = await i();
        return e.maxRetries > 0 && o.removeFunction(a), s;
      } catch (s) {
        if ((o.getMap().get(a) ?? 0) < e.maxRetries)
          return o.addFunction(a), window.location.reload(), { default: () => null };
        throw s;
      }
    });
  };
}, u = l();
export {
  f as ForceReloadStorage,
  l as createSafeLazy,
  y as defaultStorageKey,
  u as safeLazy
};
